var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-text",
                [
                  !_vm.sitebuilders.length
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "ma-0",
                          attrs: {
                            type: "info"
                          }
                        },
                        [
                          _vm._v(
                            " There are currently no active site builders activated for your hosting service. "
                          )
                        ]
                      )
                    : _c("v-data-table", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.sitebuilders
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.renewaldate",
                            fn: function fn(_ref) {
                              var item = _ref.item
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatRenewalDate(
                                        _vm.parseRenewalDate(item.renewaldate)
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            }
                          },
                          {
                            key: "item.actions",
                            fn: function fn(_ref2) {
                              var item = _ref2.item
                              return [
                                _c(
                                  "gg-btn",
                                  {
                                    attrs: {
                                      text: "",
                                      color: "primary",
                                      disabled: item.status !== "Active"
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.login(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v(" Login ")]
                                )
                              ]
                            }
                          }
                        ])
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }